import { Link } from "wouter";
import { useI18n } from "../i18n";
import { IS_DEMO } from "../lib/asset";

export function Footer() {
  const { d } = useI18n();
  return (
    <footer className="mt-24 bg-ground-2 pt-14 pb-[max(28px,env(safe-area-inset-bottom))]">
      <div className="shell">
        <p className="display text-[clamp(44px,12vw,168px)] leading-[0.9] tracking-tight">
          <span className="text-candy">HOT</span>GAMES<span className="text-flame">.GE</span>
        </p>
        <div className="mt-8 flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <p className="max-w-md text-lg text-ink-2">{d.home.footerTag}</p>
          <nav className="flex flex-wrap gap-x-6 gap-y-2 font-bold text-ink-2">
            <Link href="~/play/bluff" className="hover:text-ink">{d.games.bluff.name}</Link>
            <Link href="~/play/spy" className="hover:text-ink">{d.games.spy.name}</Link>
            <Link href="~/play/match" className="hover:text-ink">{d.games.match.name}</Link>
            <Link href="~/play/truf" className="hover:text-ink">{d.games.truf.name}</Link>
            <Link href="~/guess" className="hover:text-ink">{d.games.guess.name}</Link>
            <Link href="~/joker" className="hover:text-ink">{d.games.joker.name}</Link>
            <Link href="~/brand" className="hover:text-ink">{d.nav.brand}</Link>
          </nav>
        </div>
        <p className="mt-10 text-sm text-ink-3">
          {d.home.rights}
          {IS_DEMO && <> · {d.demo.note}</>}
        </p>
      </div>
    </footer>
  );
}
